import { ClientUserState } from '../../../../shared/scripts/ClientUserState.ts';
import { setElementInnerHTML, setElementOnClick, setImageElementAlt } from '../../../../shared/scripts/ui_utils/DomUtils.ts';
import { getLobbyImagePath } from '../../../../shared/scripts/ui_utils/Utils.ts';
import { LobbyImage } from '@colonist/types';
import { ViewPopupLogin } from '../../../../shared/scripts/ui_popup/ui_popup_membership_incentive/ViewPopupLogin.ts';
import { AnalyticEventCategory, AnalyticEventType } from '../../../../../shared/entity_datas/EntityDatas.ts';
import { CA } from '../../../../shared/scripts/analytics/Analytics.ts';
import { AudioManager, AudioType } from '@colonist/audio';
import { clientIntl } from '../../../../shared/scripts/ClientI18n.ts';
import { navigateToPage } from '../../../../shared/scripts/ui_utils/ClientUtils.ts';
export class UIHeaderProfileController {
    get discordUserStateOverrides() {
        return this._discordUserStateOverrides;
    }
    set discordUserStateOverrides(value) {
        this._discordUserStateOverrides = value;
        this.updateProfile(ClientUserState.userState);
    }
    initProfileView() {
        const userState = ClientUserState.userState;
        if (!userState) {
            this.loggedInContainers.forEach((container)=>container.classList.add('hidden'));
            this.visitorContainers.forEach((container)=>container.classList.remove('hidden'));
            this.visitorNameDivs.forEach((div)=>div.classList.add('hidden'));
            return;
        }
        const hasVisitorName = !userState.isLoggedIn && userState.username != undefined;
        this.loggedInContainers.forEach((container)=>container.classList.toggle('hidden', !userState.isLoggedIn));
        this.visitorContainers.forEach((container)=>container.classList.toggle('hidden', userState.isLoggedIn));
        this.visitorNameDivs.forEach((div)=>div.classList.toggle('hidden', !hasVisitorName));
    }
    // eslint-disable-next-line colonist/camelcase-union-values -- analytics string value
    initLoginButton(pageIdentifier) {
        Array.from(this.loginButtons).forEach((button)=>{
            setElementOnClick(button, ()=>{
                AudioManager.play(AudioType.Click);
                new ViewPopupLogin();
                void CA.sendAnalyticEvent({
                    type: AnalyticEventType.ClickedHeaderLogin,
                    category: AnalyticEventCategory.Header,
                    stringValue: pageIdentifier !== null && pageIdentifier !== void 0 ? pageIdentifier : window.location.pathname
                });
            });
        });
    }
    initProfileClick() {
        this.loggedInContainers.forEach((container)=>{
            setElementOnClick(container, ()=>{
                const userState = ClientUserState.userState;
                if (!(userState === null || userState === void 0 ? void 0 : userState.isLoggedIn)) return;
                AudioManager.play(AudioType.Click);
                navigateToPage(`${clientIntl.getLanguagePathPrefix()}/profile/${encodeURIComponent(userState.username)}`);
            });
        });
    }
    updateProfile(userState) {
        var _this_discordUserStateOverrides, _this_discordUserStateOverrides1, _this_discordUserStateOverrides2;
        if (!userState) return;
        var _this_discordUserStateOverrides_username;
        const username = (_this_discordUserStateOverrides_username = (_this_discordUserStateOverrides = this.discordUserStateOverrides) === null || _this_discordUserStateOverrides === void 0 ? void 0 : _this_discordUserStateOverrides.username) !== null && _this_discordUserStateOverrides_username !== void 0 ? _this_discordUserStateOverrides_username : userState.username;
        if (username) {
            this.usernameDivs.forEach((div)=>{
                setElementInnerHTML(div, {
                    key: 'strings:colonistCommon.utils.#buffer',
                    options: {
                        value: username
                    }
                });
            });
        }
        var _this_discordUserStateOverrides_karmaStatus;
        const karmaStatus = (_this_discordUserStateOverrides_karmaStatus = (_this_discordUserStateOverrides1 = this.discordUserStateOverrides) === null || _this_discordUserStateOverrides1 === void 0 ? void 0 : _this_discordUserStateOverrides1.karmaStatus) !== null && _this_discordUserStateOverrides_karmaStatus !== void 0 ? _this_discordUserStateOverrides_karmaStatus : userState.getPlayerKarmaStatusText();
        this.karmaDivs.forEach((div)=>{
            setElementInnerHTML(div, karmaStatus);
        });
        var _this_discordUserStateOverrides_profilePictureUrl;
        const profilePictureUrl = (_this_discordUserStateOverrides_profilePictureUrl = (_this_discordUserStateOverrides2 = this.discordUserStateOverrides) === null || _this_discordUserStateOverrides2 === void 0 ? void 0 : _this_discordUserStateOverrides2.profilePictureUrl) !== null && _this_discordUserStateOverrides_profilePictureUrl !== void 0 ? _this_discordUserStateOverrides_profilePictureUrl : userState.profilePictureUrl;
        if (profilePictureUrl) {
            this.playerIconImgs.forEach((img)=>{
                img.src = profilePictureUrl;
                img.style.borderRadius = '100%';
            });
        } else {
            var _this_discordUserStateOverrides3;
            var _this_discordUserStateOverrides_icon, _ref;
            const icon = (_ref = (_this_discordUserStateOverrides_icon = (_this_discordUserStateOverrides3 = this.discordUserStateOverrides) === null || _this_discordUserStateOverrides3 === void 0 ? void 0 : _this_discordUserStateOverrides3.icon) !== null && _this_discordUserStateOverrides_icon !== void 0 ? _this_discordUserStateOverrides_icon : userState.icon) !== null && _ref !== void 0 ? _ref : LobbyImage.Guest;
            const path = getLobbyImagePath(icon);
            this.playerIconImgs.forEach((img)=>{
                img.src = path;
                setImageElementAlt(img, icon);
            });
        }
        if (userState.isLoggedIn) {
            const currentMembership = userState.items.getCurrentMembership();
            if (currentMembership != undefined) {
                const membershipPath = getLobbyImagePath(currentMembership.image);
                this.membershipIconImgs.forEach((img)=>{
                    img.src = membershipPath;
                    img.classList.remove('hidden');
                    if (currentMembership.pending) {
                        img.style.filter = 'grayscale(1)';
                    }
                });
            }
        }
        const hasVisitorName = !userState.isLoggedIn && userState.username != undefined;
        this.loggedInContainers.forEach((container)=>container.classList.toggle('hidden', !userState.isLoggedIn));
        this.visitorContainers.forEach((container)=>container.classList.toggle('hidden', userState.isLoggedIn));
        this.visitorNameDivs.forEach((div)=>div.classList.toggle('hidden', !hasVisitorName));
        if (hasVisitorName) {
            this.visitorNameDivs.forEach((div)=>{
                setElementInnerHTML(div, {
                    key: 'strings:colonistCommon.utils.#buffer',
                    options: {
                        value: userState.username
                    }
                });
            });
        }
    }
    constructor(){
        this.usernameDivs = document.getElementsByName('web-header-username');
        this.karmaDivs = document.getElementsByName('web-header-karma');
        this.playerIconImgs = document.getElementsByName('web-header-profile-player-icon');
        this.membershipIconImgs = document.getElementsByName('web-header-profile-membership-icon');
        this.loginButtons = document.getElementsByClassName('web-header-login-button');
        this.loggedInContainers = document.getElementsByName('web-header-profile-loggedin-container');
        this.visitorContainers = document.getElementsByName('web-header-visitor-container');
        this.visitorNameDivs = document.getElementsByName('web-header-visitor-name');
        this.initProfileView();
        ClientUserState.registerChangeListener((userState)=>{
            if (userState == undefined) return;
            this.updateProfile(userState);
        });
        this.initLoginButton();
        this.initProfileClick();
    }
}
